import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { ReviewImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/reviewImpression.trackingInfo";

import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: ReviewImpressionTrackingInfo) => {
    const event: AnalyticsEvent<ReviewImpressionTrackingInfo> = {
        event: EventType.ReviewImpression,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};
